/* eslint-disable id-length */
/* eslint-disable max-lines-per-function */
import React, { Component } from 'react';
import { FormattedMessage, injectIntl } from 'react-intl';
import { ValidationMessage } from '../../common/validation-message';
import { validation, validateForm } from '../../../utils/validation';
import { returnMiladiDateByStandardFormat } from '../../../utils/utility/booking';
import { returnAvatarList } from '../../../utils/consts/avatar';
import { withRouter } from '~HOC';
import { connect } from 'react-redux';
import { countryApi, passengerApi } from '../../../services/apis';
import {
  Input,
  DatePicker,
  Dropdown,
  SwitchButton,
  Button,
} from '../../../component';

const INITIAL_DATA = {
  friendPassportExpireDate: '',
  friendPassportNo: '',
  nationalCode: '',
  countryAbr: '',
  firendAvatar: '1.png',
  gender: true,
  friendFirstName: '',
  friendLastName: '',
  friendBirthDate: '',
  friendEmail: '',
  friendMobile: '',
  friendYear: '',
  friendMonth: '',
  friendDay: '',
  friendNationalCode: '',
  friendNationality: '',
  friendCountryAbr: '',
};
const GENDER_ITEM = [{ name: 'booking.male' }, { name: 'booking.female' }];

class Friends extends Component {
  constructor(props) {
    super(props);
    this.state = {
      friendData: props.data || INITIAL_DATA,
      countryLst: [],
      errors: {},
      selectAvatar: false,
      addFriend: false,
      loading: false,
    };
  }

  async componentDidMount() {
    const { friendData } = this.state;
    const { name } = this.props.language;
    const {
      payload: { data },
    } = await countryApi.getAll();
    let country = data.filter((x) => x.name);
    this.setState({
      countryLst: country.sort((a, b) =>
        a.name[name].localeCompare(b.name[name]),
      ),
    });
    if (friendData._id) {
      let { error } = this.handleValidationFriend();
      this.setState({
        errors: error,
        friendData: { ...friendData, gender: this.props.data.isMale },
      });
    }
  }

  insert = async (event) => {
    const { friendData } = this.state,
      { onChange } = this.props;
    event.preventDefault();
    this.setState({
      loading: true,
    });
    const { result, error } = this.handleValidationFriend();
    if (result) {
      const nationality = this.state.countryLst.find(
        (item) => item.code === friendData.friendNationality,
      );
      const body = {
        _id: friendData?._id ?? 0,
        firstName: friendData.friendFirstName,
        lastName: friendData.friendLastName,
        birthDate: friendData.friendBirthDate,
        passportExpireDate: friendData.friendPassportExpireDate,
        passportNo: friendData.friendPassportNo,
        nationalCode: friendData.friendNationalCode,
        nationality,
        type: 'adult',
        passportCountry: friendData.friendNationality,
        isMale: friendData.gender,
        avatar: friendData.firendAvatar,
      };
      try {
        const { status } = await passengerApi.insert({ data: body });
        if (status === 200) {
          onChange({
            isOpen: true,
            status: 'success',
            alertMessage: 'profile.quotaadd',
          });
          this.setState({
            addFriend: false,
            friendData: INITIAL_DATA,
            loading: false,
          });
        } else {
          onChange({
            isOpen: true,
            status: 'danger',
            alertMessage: 'user.tryagain',
          });
        }
      } catch (error) {
        onChange({
          isOpen: true,
          status: 'danger',
          alertMessage: 'booking.servererror',
        });
      }
    } else {
      this.setState({ errors: error });
    }
  };

  update = async (event) => {
    const { friendData } = this.state,
      { onChange } = this.props;
    event.preventDefault();
    this.setState({
      loading: true,
    });
    const { result, error } = this.handleValidationFriend();
    if (result) {
      const nationality = this.state.countryLst.find(
        (item) => item.code === friendData.friendNationality,
      );
      const body = {
        _id: friendData?._id ?? 0,
        firstName: friendData.friendFirstName,
        lastName: friendData.friendLastName,
        birthDate: friendData.friendBirthDate,
        passportExpireDate: friendData.friendPassportExpireDate,
        passportNo: friendData.friendPassportNo,
        nationalCode: friendData.friendNationalCode,
        nationality,
        type: 'adult',
        passportCountry: friendData.friendNationality,
        isMale: friendData.gender,
        avatar: friendData.firendAvatar,
      };
      try {
        const { status } = await passengerApi.update({ data: body });
        if (status === 200) {
          onChange({
            isOpen: true,
            status: 'success',
            alertMessage: 'department.departmentaddInformation',
          });
          this.setState({
            addFriend: false,
            friendData: INITIAL_DATA,
            loading: false,
          });
        } else {
          onChange({
            isOpen: true,
            status: 'danger',
            alertMessage: 'user.tryagain',
          });
        }
      } catch (error) {
        onChange({
          isOpen: true,
          status: 'danger',
          alertMessage: 'booking.servererror',
        });
      }
    } else {
      this.setState({ errors: error });
    }
  };

  handleValidationFriend = () => {
    const {
      friendFirstName,
      friendLastName,
      friendNationality,
      friendNationalCode,
      friendBirthDate,
      friendPassportExpireDate,
      friendPassportNo,
    } = this.state.friendData;
    const { error, result } = validateForm({
      friendFirstName: validation.english(friendFirstName).required().errors,
      friendLastName: validation.english(friendLastName).required().errors,
      friendNationalCode:
        friendNationality === 'IR' || friendNationality === ''
          ? validation.iranianNationalCode(friendNationalCode).required().errors
          : [],
      friendBirthDate: validation.required(friendBirthDate).errors,
      friendPassportExpireDate:
        friendNationality !== 'IR'
          ? validation.required(friendPassportExpireDate).errors
          : validation.optional(friendPassportExpireDate).errors,
      friendPassportNo:
        friendNationality !== 'IR'
          ? validation.passportNo(friendPassportNo).required().errors
          : validation.text(friendPassportNo).optional().errors,
      friendNationality: validation.required(friendNationality).errors,
    });
    return { error, result };
  };

  handleChangeFriend = (event) => {
    const { currentTarget: input } = event;
    const { friendData, errors } = this.state;
    let data = structuredClone(friendData);
    data[input.name] = input.value;
    this.setState({ friendData: data }, () => {
      this.setState({
        errors: {
          ...errors,
          [input.name]: this.handleValidationFriend().error[input.name],
        },
      });
    });
  };

  changeGender = (type) => {
    this.setState((state) => {
      state.friendData.gender = type.toLowerCase() === 'male' ? true : false;
      return state;
    });
  };

  avatar = () => {
    const { friendData } = this.state;
    return (
      <div className="d-flex flex-column">
        <div className=" d-flex row justify-content-center">
          {returnAvatarList().map((item, index) => {
            return (
              <div key={index} className="m-2">
                <div
                  className={'d-flex py-2'}
                  onClick={() => {
                    this.setState({
                      friendData: { ...friendData, firendAvatar: item },
                      selectAvatar: false,
                    });
                  }}
                >
                  <img
                    className="cursor-pointer"
                    src={require(`../../../content/images/avatars/${item}`)}
                    alt="avatars"
                    style={{ width: 65, height: 65 }}
                  />
                </div>
              </div>
            );
          })}
        </div>
      </div>
    );
  };

  addFriendFrom = () => {
    const { friendData, errors, countryLst, loading } = this.state;
    const {
      language,
      title = 'profile.addfriend',
      text = 'profile.textFriend',
      intl,
    } = this.props;
    return (
      <form
        id="friend-form"
        name="friend-form"
        onSubmit={(event) => {
          friendData?._id ? this.update(event) : this.insert(event);
        }}
        className="d-flex flex-column justify-content-center align-items-center w-100 px-0"
      >
        <div className="col-12 px-0 pb-3 d-flex flex-xs-row flex-column">
          <div className="flex-grow-1 invite-form-container col-md-6 col-xs-7 w-100 px-md-3 px-0 ">
            <div className="w-100 d-flex flex-row justify-content-start ">
              <img
                className="img-fluid default-border-radius-small w-100 img-setup"
                alt=""
                src={require('../../../content/images/elements/addFriend.png')}
              />
            </div>
          </div>
          <div className="col-md-6 col-xs-5 col-12 px-md-3 px-xs-1 px-3 py-xs-0 py-3 d-flex flex-column justify-content-start align-items-start">
            <div className="w-100 d-flex flex-column justify-content-start align-items-start">
              <span className="text-primary pt-md-5 pt-2 font-sm-xxlarge font-normal text-nowrap">
                <FormattedMessage id={`${title}`} />
              </span>
              <div className="col-md-10 w-100 text-third text-start pt-md-4 pt-sm-3 pt-1 px-0">
                <p className="font-xl-small font-sm-msmall font-xs-xsmall font-msmall lineHeight">
                  <FormattedMessage id={`${text}`} />
                </p>
              </div>
            </div>
            <div
              style={{ zIndex: 1 }}
              className="w-100 m-0 py-0 d-sm-inline d-none pt-4"
            >
              <div
                className="d-flex w-100 cursor-pointer justify-content-start align-items-center"
                onClick={() => {
                  this.setState({ selectAvatar: true });
                }}
              >
                <img
                  src={require(`../../../content/images/avatars/${friendData.firendAvatar}`)}
                  alt="firendAvatar"
                  style={{ width: 48, height: 48 }}
                />
                <span className="d-flex font-weight-bold px-3 font-smaller text-nowrap text-start">
                  <FormattedMessage id="profile.selectavatar" />
                </span>
              </div>
            </div>
          </div>
        </div>
        <div
          style={{ zIndex: 1 }}
          className="w-100 m-0 py-2 d-sm-none d-inline"
        >
          <div
            className="d-flex w-100 cursor-pointer justify-content-start align-items-center pb-3"
            onClick={() => {
              this.setState({ selectAvatar: true });
            }}
          >
            <img
              src={require(`../../../content/images/avatars/${friendData.firendAvatar}`)}
              alt="firendAvatar"
              style={{ width: 48, height: 48 }}
            />
            <span className="d-flex font-weight-bold px-3 font-smaller text-nowrap text-start">
              <FormattedMessage id="profile.selectavatar" />
            </span>
          </div>
        </div>
        <div
          className="bg-primary-dark-lighter mt-3 mb-3  align-items-end d-flex  row w-100"
          style={{ borderRadius: '30px' }}
        >
          <fieldset className="d-flex flex-column px-2 col-12 col-md-6 m-0 pb-sm-4 pb-3">
            <Input
              name="friendFirstName"
              label={intl.formatMessage({
                id: 'booking.englishname',
              })}
              type="text"
              className=""
              tabIndex="1"
              inputClassName="font-normal height-input-profile px-sm-3 px-3"
              disabled={false}
              themeMode="light"
              outSideLabel={true}
              outSideLabelClass=""
              outSideLabelPosition="top"
              iconUrl={null}
              value={friendData['friendFirstName']}
              onChange={(event) => this.handleChangeFriend(event)}
              language={language}
            />
            <ValidationMessage errors={errors['friendFirstName']} />
          </fieldset>
          <fieldset className="d-flex flex-column px-2 col-12 col-md-6 m-0 pb-sm-4 pb-3">
            <Input
              name="friendLastName"
              label={intl.formatMessage({
                id: 'booking.englishlastname',
              })}
              type="text"
              className=""
              tabIndex="2"
              inputClassName="font-normal height-input-profile px-sm-3 px-3"
              disabled={false}
              themeMode="light"
              outSideLabel={true}
              outSideLabelClass=""
              outSideLabelPosition="top"
              iconUrl={null}
              value={friendData['friendLastName']}
              onChange={(event) => this.handleChangeFriend(event)}
              language={language}
            />
            <ValidationMessage errors={errors['friendLastName']} />
          </fieldset>
          <fieldset className="d-flex flex-column px-2 col-12 col-md-6 m-0 pb-sm-4 pb-3">
            <Dropdown
              name="friendNationality"
              id="friendNationality"
              label="booking.passportcountry"
              options={{
                data: countryLst,
                value: 'code',
                label: 'name',
                isMultiLanguage: true,
              }}
              classNames="bg-third-light"
              withoutShadow={true}
              tabIndex="3"
              hasChild=""
              outSideLabel={true}
              labelPosition="top"
              iconNameDrp={null}
              outSideLabelClass="dropDown-fontSize"
              value={friendData.friendNationality}
              onChange={(e) => {
                this.handleChangeFriend(e);
              }}
            />
            <ValidationMessage errors={errors['friendNationality']} />
          </fieldset>
          <fieldset className="d-flex flex-column px-2 col-12 col-md-6 m-0 pb-sm-4 pb-3">
            <div className="d-flex w-100">
              <div className="d-md-flex flex-row w-100 align-items-center">
                <div className="col-12 px-0 ">
                  <DatePicker
                    name={'friendBirthDate'}
                    value={friendData['friendBirthDate']}
                    placeholder={intl.formatMessage({
                      id: 'booking.birthday',
                    })}
                    className=""
                    tabIndex="4"
                    inputClassName={'font-normal'}
                    outSideLabelClassname={'dropDown-fontSize'}
                    themeMode="light"
                    onChange={(date) => {
                      this.handleChangeFriend({
                        currentTarget: {
                          value: returnMiladiDateByStandardFormat(date),
                          name: 'friendBirthDate',
                        },
                      });
                    }}
                    outSideLabel={true}
                    withoutShadow={true}
                  />
                </div>
              </div>
            </div>
            <ValidationMessage errors={errors['friendBirthDate']} />
          </fieldset>
          {friendData.friendNationality === 'IR' ||
          !friendData.friendNationality ? (
            <fieldset className="d-flex flex-column px-2 col-12 col-md-6 m-0 pb-sm-4 pb-3">
              <Input
                name="friendNationalCode"
                label={intl.formatMessage({
                  id: 'profile.nationalcode',
                })}
                type="text"
                className=""
                tabIndex="4"
                inputClassName="font-normal height-input-profile px-sm-3 px-3"
                disabled={false}
                themeMode="light"
                outSideLabel={true}
                outSideLabelClass=""
                outSideLabelPosition="top"
                iconUrl={null}
                value={friendData['friendNationalCode']}
                onChange={(event) => this.handleChangeFriend(event)}
                language={language}
              />
              <ValidationMessage errors={errors['friendNationalCode']} />
            </fieldset>
          ) : (
            <>
              <fieldset className="d-flex flex-column px-2 col-12 col-md-6 m-0 pb-sm-4 pb-3">
                <Input
                  name="friendPassportNo"
                  label={intl.formatMessage({
                    id: 'booking.passportno',
                  })}
                  type="text"
                  className=""
                  tabIndex="5"
                  inputClassName="font-normal height-input-profile px-sm-3 px-3 col-12 col-md-6"
                  disabled={false}
                  themeMode="light"
                  outSideLabel={true}
                  outSideLabelClass=""
                  outSideLabelPosition="top"
                  iconUrl={null}
                  value={friendData.friendPassportNo}
                  onChange={(event) => this.handleChangeFriend(event)}
                  language={language}
                />
                <ValidationMessage errors={errors['friendPassportNo']} />
              </fieldset>
              <fieldset className="d-flex flex-column px-2 col-12 col-md-6 m-0 pb-sm-4 pb-3">
                <div className="d-flex w-100">
                  <div className="d-md-flex flex-row w-100 align-items-center">
                    <div className="col-12 px-0">
                      <DatePicker
                        name={'friendPassportExpireDate'}
                        value={friendData.friendPassportExpireDate}
                        placeholder={intl.formatMessage({
                          id: 'booking.passportexpiredate',
                        })}
                        className="pt-4"
                        tabIndex="6"
                        inputClassName={'font-normal'}
                        outSideLabelClassname={'dropDown-fontSize'}
                        themeMode="light"
                        onChange={(date) => {
                          this.handleChangeFriend({
                            currentTarget: {
                              value: returnMiladiDateByStandardFormat(date),
                              name: 'friendPassportExpireDate',
                            },
                          });
                        }}
                        outSideLabel={true}
                        withoutShadow={true}
                      />
                    </div>
                  </div>
                </div>
                <ValidationMessage
                  errors={this.state.errors['friendPassportExpireDate']}
                />
              </fieldset>
            </>
          )}
          <fieldset className="d-flex flex-column px-2 col-12 col-md-6 m-0 pb-sm-4 pb-3">
            <span className=" d-flex w-100 justify-content-start text-dark px-3 font-normal">
              <FormattedMessage id="profile.gender" />
            </span>
            <div className="w-100 d-flex pt-2 ">
              <SwitchButton
                active={`booking.${friendData.gender ? 'male' : 'female'}`}
                items={GENDER_ITEM}
                containerStyle="d-flex col py-2 pt-1 px-0 border border-forth-light default-border-radius-small bg-third-light"
                onclick={(item) => this.changeGender(item)}
                itmesStyle="p-sm-2 p-1 "
                activeClass="bg-secondary default-border-radius-small"
              />
            </div>
            <ValidationMessage errors={errors?.['gender']} />
          </fieldset>
          <div className="d-flex col-12 px-0 justify-content-end">
            <fieldset className="d-flex flex-row justify-content-end align-items-center pt-2 mt-2 px-2 pb-0 label-small col-12 col-md-6">
              <Button
                id="friend-form-submit"
                name="friend-form-submit"
                label={intl.formatMessage({
                  id: `profile.${
                    friendData?._id ? 'editinformation' : 'insertinformation'
                  }`,
                })}
                type="submit"
                loading={loading}
                disabled={loading || !this.handleValidationFriend().result}
                className="btn-secondary"
                tabIndex="7"
              />
            </fieldset>
          </div>
        </div>
      </form>
    );
  };

  render() {
    const { selectAvatar } = this.state;
    return <> {selectAvatar ? this.avatar() : this.addFriendFrom()}</>;
  }
}

function mapStateToProps(state) {
  return {
    language: state.language,
  };
}

export default injectIntl(withRouter(connect(mapStateToProps)(Friends)));
